import {Injectable}    from '@angular/core';
import {IGridStatus}   from '../../../ap-interface/interfaces/ap-grid-status.interface';
import {ApColumnState} from '../../../ap-interface/enums/ap-column-state.enum';
import IGuid = System.IGuid;

@Injectable({providedIn: 'root'})
export class ResourcesDataService {
  public getResourceStatus(item: {
    IsDeleted: boolean | undefined,
    DeletedAt: Date | undefined,
    DeletedBy: IGuid | undefined
  } | undefined): IGridStatus {
    const isActive = this.isResourceActive(item);
    return {
      state: isActive ? ApColumnState.Green : ApColumnState.Red,
      class: isActive ? 'ap-status-green' : 'ap-status-red',
      description: isActive ? 'Global__Active' : 'Global__Inactive'
    };
  }

  public isResourceActive(item: {
    IsDeleted: boolean | undefined,
    DeletedAt: Date | undefined,
    DeletedBy: IGuid | undefined
  } | undefined): boolean {
    return !!item && !item.IsDeleted && !item.DeletedAt && !item.DeletedBy;
  }
}
